var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9677 2.60671V0H1.03226V2.60671C0.444129 2.72671 0 3.248 0 3.87097V13.1613C0 13.8728 0.578839 14.4516 1.29032 14.4516H4.12903V15.4839H3.09677V16H12.9032V15.4839H11.871V14.4516H14.7097C15.4212 14.4516 16 13.8728 16 13.1613V3.87097C16 3.248 15.5559 2.72671 14.9677 2.60671ZM14.4516 0.516129V2.06452H13.9355V2.58065H14.4516V11.3548H1.54839V2.58065H13.4194V2.06452H1.54839V0.516129H14.4516ZM1.03226 3.14426V11.871H14.9677V3.14426C15.2674 3.2511 15.4839 3.53497 15.4839 3.87097V12.3871H0.516129V3.87097C0.516129 3.53497 0.732645 3.2511 1.03226 3.14426ZM11.3548 15.4839H4.64516V14.4516H11.3548V15.4839ZM14.7097 13.9355H1.29032C0.863484 13.9355 0.516129 13.5881 0.516129 13.1613V12.9032H15.4839V13.1613C15.4839 13.5881 15.1365 13.9355 14.7097 13.9355Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58058 1.03125H2.06445V1.54738H2.58058V1.03125Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61379 1.03125H3.09766V1.54738H3.61379V1.03125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64504 1.03125H4.12891V1.54738H4.64504V1.03125Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12891 10.8396H11.8708V3.09766H4.12891V10.8396ZM4.64504 8.77508H6.19342V10.3235H4.64504V8.77508ZM6.70955 10.3235V8.25895H4.64504V5.6783H6.70955V3.61379H9.2902V5.6783H11.3547V10.3235H6.70955ZM11.3547 5.16217H9.80633V3.61379H11.3547V5.16217ZM6.19342 3.61379V5.16217H4.64504V3.61379H6.19342Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7105 6.19531H5.16211V6.71144H6.7105V6.19531Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8384 4.12891H10.3223V4.64504H10.8384V4.12891Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67824 4.12891H5.16211V4.64504H5.67824V4.12891Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67824 9.28906H5.16211V9.80519H5.67824V9.28906Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67824 7.22656H5.16211V7.74269H5.67824V7.22656Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70949 7.22656H6.19336V7.74269H6.70949V7.22656Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77495 5.16116H7.74269V4.12891H7.22656V5.67729H8.77495V5.16116Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74269 6.19531H7.22656V7.7437H7.74269V6.19531Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74269 8.25781H7.22656V9.8062H7.74269V8.25781Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29007 6.19531H8.25781V6.71144H9.29007V6.19531Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80664 6.71144H10.3228V7.7437H10.8389V6.19531H9.80664V6.71144Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77394 7.22656H8.25781V8.77495H8.77394V7.22656Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8062 9.28906H8.25781V9.80519H9.8062V9.28906Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80519 7.22656H9.28906V7.74269H9.80519V7.22656Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80519 8.25781H9.28906V8.77394H9.80519V8.25781Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8384 8.25781H10.3223V9.8062H10.8384V8.25781Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.c88d043f178f5d81dfff6c33627ba696.svg";
export { ForwardRef as ReactComponent };